<script setup>
const props = defineProps({
  text: String,
})
const { t } = useI18n()
</script>

<template>
  <DSAlert
    type="info"
    no-close
  >
    <strong>{{ t('No events') }}.</strong> {{ text }}.
  </DSAlert>
</template>

<i18n>
{
  "en-us": {
    "No events": "No events"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "No events": "Keine Veranstaltungen"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "No events": "Aucun événement"
}
</i18n>

<i18n locale="es" lang="json">
{
  "No events": "No hay eventos"
}
</i18n>
